import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Spinner = ({ className, ...props }) => (
  <span {...props} className={classNames('spinner', className)}/>
);

Spinner.propTypes = {
  className: PropTypes.string
};

export default Spinner;
